<div class="mini-widget">
  <div class="header">
    <div class="title">
      <ion-icon name="ds-tree"></ion-icon>
      <p class="ds-heading-3">{{'SHARED.projectMini.widget.title' | translate:{percentage: (percentage >=  1 ? 1 : percentage) | percent} }}</p>
    </div>
    <app-ds-progress-bar [type]=" percentage * 100  >= 100 ? 'success' : 'info'" [percentage]="percentage >=  1 ? 100 : percentage * 100"></app-ds-progress-bar>
  </div>
  <div class="status">
    <p class="ds-ui-3 ds-color-core-neutral-7">
      <ng-container *ngIf="amount <= 0; else leftAmount">
        {{ 'SHARED.projectMini.widget.goalReached' | translate }}
      </ng-container>
      <ng-template #leftAmount>
        {{'SHARED.projectMini.widget.leftAmount' | translate: { amount: amount | thousand:currency } }}
      </ng-template>
    </p>
    <div class="status-icon">
      <ion-icon name="info2" (click)="showMiniWidgetInfo = !showMiniWidgetInfo"></ion-icon>
    </div>
  </div>
  <div *ngIf="showMiniWidgetInfo" class="mini-info">
    <p class="ds-ui-3 ds-color-core-neutral-7">{{ 'SHARED.projectMini.widget.info' | translate }}</p>
  </div>
</div>
